export default "__VITE_ASSET__f6nHrquN__"